import React, { useState, useEffect } from "react";
import { useForm } from "react-hook-form";
import { SaveBtn } from "../components/saveBtn";
import { CancelBtn } from "../components/cancelBtn";
import { useNavigate, useParams } from "react-router-dom";
import axios from "axios";
function EditClient() {


  const API_URL = process.env.REACT_APP_API_URL;

  const { id } = useParams();
  const [client, setClient] = useState();
  const [fetchLoading, setFetchLoading] = useState(true);
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState(null);
  const [cancelClicked, setCancelClicked] = useState(false);

  const [formData, setFormData] = useState({
    name: "",
    gender: "",
    email: "",
    contact: "",
    membership: "",
    prepaid: "",
  });

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const navigate = useNavigate();

  const {
    register,
    formState: { errors, isValid },
    handleSubmit,
  } = useForm({ mode: "onSubmit" });

  useEffect(() => {
    axios
      .get(`${API_URL}/clients/${id}`)
      .then((response) => {
        setClient(response.data);
        setFormData(response.data);
        setFetchLoading(false);
      })
      .catch((err) => {
        setError(err.message);
        setFetchLoading(false);
      });
  }, [id, API_URL]);

  if (fetchLoading) {
    return <div>Loading...</div>;
  }
  if (error) {
    return <div>Error: {error}</div>;
  }

  const onCancel = () => {
    setCancelClicked(true);
    navigate(`/clients/${id}`);
  };

  const onSubmit = async (data, event) => {
    const action = event.nativeEvent.submitter.value;
    if(action !== "submit"){
      return;
    } else{
      try {
        setIsLoading(true);
        const response = await axios.put(
          `${API_URL}/clients/${id}`,
          formData
        );
        if (response.data != null && !cancelClicked) {
          alert(response.data.message);
          navigate(`/clients/${id}`);
        }
      } catch {
        setError(
          "Something went wrong while updaing the client. Please try again later"
        );
        alert(error);
      }
    }
   
  };
  function parseMoney(str) {
    const cleanStr = str.replace(/[^\d.-]/g, "");
    const amount = parseFloat(cleanStr);
    return amount;
  }
  return (
    <div className="h-dvh flex items-center flex-col bg-[#545454]">
      <title>Edit Client | HairBank</title>
      <div className="flex w-4/5 items-end text-center">
        <div className="w-full">
          <h1 className="text-[#eed495] text-6xl mt-16 xl:mt-5 w-full">
            Edit Client
          </h1>
        </div>
      </div>
      <form onSubmit={handleSubmit(onSubmit)}>
        <div className="flex border-2 mt-20 flex-col h-auto justify-center">
          <div className="flex items-center justify-center">
            <div className="w-40 text-white text-2xl m-2">
              <label htmlFor="name">Name:</label>
            </div>
            <div>
              <input
                {...register("name", {
                  required: "Name is required",
                })}
                name="name"
                onChange={handleChange}
                required
                type="text"
                defaultValue={client && client.name}
                className="w-72 text-2xl text-white bg-[#7a7a7a] focus:outline-none m-3 focus:border-gray-500 p-3 border-2 font-light border-gray-200 "
              />
            </div>
          </div>
          <div className="flex items-center">
            <div className="w-36 text-white text-2xl m-3">
              <label htmlFor="gender">Gender:</label>
            </div>
            <div>
              <select
                id="genders"
                name="gender"
                className="text-2xl w-32 ml-5"
                value={formData.gender}
                onChange={handleChange}
              >
                <option value="Female">Female</option>
                <option value="Male">Male</option>
              </select>
            </div>
          </div>
          <div className="flex items-center">
            <div className="w-40 text-white text-2xl m-2">
              <label htmlFor="Email">Email:</label>
            </div>
            <div>
              <input
                {...register("email", {
                  required: "Email is required",
                  pattern: {
                    value: /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,4}$/,
                    message: "Invalid email address",
                  },
                })}
                name="email"
                type="text"
                onChange={handleChange}
                defaultValue={client && client.email}
                className="w-72 text-2xl text-white bg-[#7a7a7a] focus:outline-none m-3 focus:border-gray-500 p-3 border-2 font-light border-gray-200 "
              />
            </div>
          </div>
          {errors.email?.message && (
            <div className="text-2xl text-red-400 text-center">
              <span>{errors.email?.message}</span>
            </div>
          )}
          <div className="flex items-center">
            <div className="w-40 text-white text-2xl m-2">
              <label htmlFor="contact">Contact:</label>
            </div>
            <div>
              <input
                {...register("contact", {
                  required: "Contact is required",
                })}
                name="contact"
                type="text"
                onChange={handleChange}
                defaultValue={client && client.contact}
                className="w-72 text-2xl text-white bg-[#7a7a7a] focus:outline-none m-3 focus:border-gray-500 p-3 border-2 font-light border-gray-200 "
              />
            </div>
          </div>
          <div className="flex items-center">
            <div className="w-40 text-white text-2xl m-2">
              <label htmlFor="membership">Membership:</label>
            </div>
            <div>
              <select
                id="memberships"
                name="membership"
                onChange={handleChange}
                value={formData.membership}
                className="text-2xl w-32 ml-3"
              >
                <option value="None">None</option>
                <option value="Silver">Silver</option>
                <option value="Gold">Gold</option>
                <option value="V.I.P">V.I.P</option>
              </select>
            </div>
          </div>
          <div className="flex items-center">
            <div className="w-40 text-white text-2xl m-2">
              <label htmlFor="prepaid">Prepaid:</label>
            </div>
            <div>
              <input
                {...register("prepaid", {
                  required: "Prepaid is required",
                })}
                name="prepaid"
                type="number"
                min="0.00"
                step="0.01"
                onChange={handleChange}
                defaultValue={client && parseMoney(client.prepaid)}
                className="w-72 text-2xl text-white bg-[#7a7a7a] focus:outline-none m-3 focus:border-gray-500 p-3 border-2 font-light border-gray-200 "
              />
            </div>
          </div>
        </div>
        <div className="flex justify-center gap-10">
          <SaveBtn
            canClick={isValid}
            isLoading={isLoading}
            actionText={"Save"}
            onClick={onSubmit}
          />
          <CancelBtn actionText={"Cancel"} onClick={onCancel} />
        </div>
      </form>
    </div>
  );
}

export default EditClient;
